export const OTP_LENGTH = 6;
export const FOCUS_DELAY = 100;
export const AVATAR_BASE_URL = 'https://avatar.iran.liara.run/username?username=';
export const HASH_LENGTH = 8;

export const AUTH_ENDPOINTS = {
  LOGIN: '/api/login',
  USER_PROFILE: '/api/v1/users/profile',
} as const;

export const FORM_VALIDATION = {
  EMAIL_MIN_LENGTH: 1,
  CODE_MIN_LENGTH: 6,
} as const;
